import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Logo } from "./Logo";
import { Instagram, Linkedin, Facebook, Lock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function Footer() {
  const [social, setSocial] = useState({ instagram: "", linkedin: "", facebook: "" });

  useEffect(() => {
    axios
      .get(`${API}/site/social`)
      .then((r) => setSocial(r.data || {}))
      .catch(() => {
        /* silently ignore — footer icons just won't render */
      });
  }, []);

  const socialLinks = [
    { url: social.instagram, Icon: Instagram, label: "Instagram", testId: "footer-social-instagram" },
    { url: social.linkedin, Icon: Linkedin, label: "LinkedIn", testId: "footer-social-linkedin" },
    { url: social.facebook, Icon: Facebook, label: "Facebook", testId: "footer-social-facebook" },
  ].filter((s) => s.url && s.url.trim());

  return (
    <footer className="bg-white border-t border-brand-navy/10 py-14" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <div>
            <Logo tone="dark" />
            <p className="mt-4 text-sm text-brand-slate/70 max-w-sm leading-relaxed">
              An AI-powered operations platform that turns daily execution into
              effortless compliance.
            </p>
          </div>
          <nav className="flex flex-wrap items-center gap-x-8 gap-y-3" aria-label="Footer">
            <a href="#about" className="text-[11px] uppercase tracking-[0.25em] text-brand-navy/70 hover:text-brand-orange" data-testid="footer-link-about">About</a>
            <a href="#industries" className="text-[11px] uppercase tracking-[0.25em] text-brand-navy/70 hover:text-brand-orange" data-testid="footer-link-industries">Industries</a>
            <a href="#workflow" className="text-[11px] uppercase tracking-[0.25em] text-brand-navy/70 hover:text-brand-orange" data-testid="footer-link-workflow">Process</a>
            <a href="#enquiry" className="text-[11px] uppercase tracking-[0.25em] text-brand-navy/70 hover:text-brand-orange" data-testid="footer-link-enquiry">Book a review</a>
          </nav>
        </div>

        <div className="mt-10 border-t border-brand-navy/10 pt-6 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <p className="text-[10px] uppercase tracking-[0.4em] text-brand-navy/50" data-testid="footer-tagline">
            Total Clarity. Without Complexity.
          </p>
          {socialLinks.length > 0 && (
            <div className="flex items-center gap-5 text-brand-navy/50">
              {socialLinks.map(({ url, Icon, label, testId }) => (
                <a
                  key={label}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="hover:text-brand-orange transition-colors"
                  data-testid={testId}
                >
                  <Icon size={16} strokeWidth={1.5} />
                </a>
              ))}
            </div>
          )}
          <div className="flex items-center gap-4">
            <p className="text-[10px] tracking-wider text-brand-navy/40">© {new Date().getFullYear()} Vanguard Beacon</p>
            <Link
              to="/admin/login"
              aria-label="Admin sign in"
              title="Sign in"
              className="text-brand-navy/30 hover:text-brand-navy/70 transition-colors"
              data-testid="footer-link-admin"
            >
              <Lock size={12} strokeWidth={1.5} />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
